import { get } from '@/libs/http';
import { type DecayStatusRes, type DetailRes } from '@/types/api/vip/detail.d';
import { createApiQuery } from '@/hooks/use-api-query';
import type { BenefitCustomNicknameRes } from '@/types/api/vip/benefit-custom-nickname';
import type { ConfigDetailRes } from '@/types/api/vip/config-detail';
import type { BenefitDedicatedSupportDetailRes } from '@/types/api/vip/benefit-dedicated-support-detail';

export const getVipDetail = (): Promise<DetailRes> => {
  return get<DetailRes>('/member/my/v1/detail');
};

export const getBenefitCustomNickname = (): Promise<BenefitCustomNicknameRes> => {
  return get<BenefitCustomNicknameRes>('/member/my/v1/benefit/customNickname');
};
export const useBenefitCustomNickname = createApiQuery(getBenefitCustomNickname, () => []);

export const useGetVipDetail = createApiQuery(getVipDetail, () => ['vip-detail']);

export const getVipStatus = (): Promise<DecayStatusRes> => {
  return get<DecayStatusRes>('/member/my/v1/status');
};

export const getVipConfigDetail = (): Promise<ConfigDetailRes> => {
  return get<ConfigDetailRes>('/member/config/v1/config/detail');
};
export const useGetVipConfigDetail = createApiQuery(getVipConfigDetail, () => ['vip-config-detail']);

export const getVipContact = (): Promise<BenefitDedicatedSupportDetailRes> => {
  return get<BenefitDedicatedSupportDetailRes>('/member/my/v1/benefit/dedicated_support/detail');
};
export const useGetVipContact = createApiQuery(getVipContact, () => ['vip-contact-config']);